import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import {FormControl} from '@angular/forms';
import * as _ from 'lodash';

@Component({
    selector: 'app-forms-toggle',
    //templateUrl: 'views/main.html'
    template: `
        <label class="form-check-inline u-check mx-0 mb-0">
            <input id="{{formItem.key}}"
                   [formControl]="controlItem"
                   class="g-hidden-xs-up g-pos-abs g-top-0 g-right-0"
                   name="{{formItem.key}}"
                   type="checkbox"
                   (click)="onValueChange()">
            <div class="u-check-icon-radio-v7">
                <i class="d-inline-block"></i>
            </div>
        </label>
    `
})
export class ToggleComponent implements OnInit, OnChanges {

    @Input()
    formItem: any;

    @Input()
    value: any;

    @Input()
    useSettingsValue: boolean;

    @Input()
    float: boolean;

    @Output()
    selected: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    onValueChangeEmitter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    inputAttr: string;

    @Input()
    inputColor: string;

    @Input()
    inputBarAttr: string;

    controlItem: FormControl = new FormControl({value: false, disabled: false});
    constructor() {
    }

    ngOnInit(){
        if(!_.isEmpty(this.formItem.value))
            this.controlItem.setValue(this.formItem.value);

        if(!_.isEmpty(this.formItem.validators)){
            this.controlItem.setValidators(this.formItem.validators);
            this.controlItem.valueChanges.subscribe(() => {
                if(!this.controlItem.value){
                    this.controlItem.setErrors({required: true})
                }
            });
        }

        if(this.useSettingsValue === true) {
            this.controlItem.setValue(this.value);
        }

        this.selected.emit(this.controlItem);

    }

    ngOnChanges(changes: SimpleChanges) {
        this.controlItem.setValue(this.value);
    }

    onValueChange() {
        setTimeout(() => {
            this.onValueChangeEmitter.emit(this.controlItem.value);
        }, 100);
    }

}
